// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ae0b25d6","160":"3793f2fe","208":"6f3725bc","293":"76978a0a","516":"baef67d9","519":"4efdad3e","917":"53f78219","942":"de00ce00","946":"912d91f1"}[chunkId] + ".chunk.js";
};